// THIS FILE WAS AUTOGENERATED
"use strict";
    
    /**
     * The abstract common base of all domains.
     */
    class Domain
    {
        
        constructor()
        {
        }
    }
export = Domain;
